import React from "react";
import HeaderMenu from "./pages/home/header/header-menu";
import {
   Switch,
   Route
} from "react-router-dom";
import HomeContent from "./pages/home/body/home-content";
import Autobiography from "./pages/about/autobiography";
import OurMessageToYou from "./pages/about/our-message-to-you";
import Books from "./pages/books/books";
import Hajj from "./pages/hajj/hajj";
import Itikaf from "./pages/hajj/itikaf";
import Mursidlerim from "./pages/mursidlerim/mursidlerim";
import Sema from "./pages/sema/sema";
import { BackTop } from "antd";
import Gallery from "./pages/gallery/gallery";
import Mukabele from "./pages/mukabele/mukabele";
import Footer from "./pages/home/body/footer";
import Hidayet from "./pages/hidayet/hidayet";
import "./App.scss";

interface AppProps {

}
interface AppState {
   IsScrollBackBtnVisible: boolean;
}

class App extends React.Component<AppProps, AppState> {
   constructor(props: any) {
      super(props);
      document.body.classList.add('sema-app');
      this.state = {
         IsScrollBackBtnVisible: false
      };
   }


   componentDidMount(): void {
      window.addEventListener('scroll', this.handleScroll);
   }
   handleScroll = () => {
      let isVisible = false
      if (window.scrollY > 400) {
         isVisible = true
      }
      this.setState({ IsScrollBackBtnVisible: isVisible })
   };

   render() {
      return (
         <div className="main-wrapper">
            <HeaderMenu isScrollBackBtnVisible={this.state.IsScrollBackBtnVisible} />

            <div className="main">
               <main className="main__content">

                  <Switch>
                     <Route path="/" exact>
                        <HomeContent />
                     </Route>
                     <Route path="/hakkimizda/baskan-hakkinda">
                        <Autobiography />
                     </Route>
                     <Route path="/hakkimizda/size-olan-mesajimiz">
                        <OurMessageToYou />
                     </Route>
                     <Route path="/mursidlerim/muzaffer-aski-ozak">
                        <Mursidlerim isFirstSubMenu={true} />
                     </Route>
                     <Route path="/mursidlerim/sefer-dal">
                        <Mursidlerim isFirstSubMenu={false} />
                     </Route>
                     <Route path="/sema">
                        <Sema />
                     </Route>
                     <Route path="/books">
                        <Books />
                     </Route>
                     <Route path="/hacc-hatiralari">
                        <Hajj />
                     </Route>
                     <Route path="/itikaf-hatiralari">
                        <Itikaf />
                     </Route>
                     <Route path="/mukabele">
                        <Mukabele />
                     </Route>
                     <Route path="/galeri">
                        <Gallery />
                     </Route>
                     <Route path="/allahin-hidayet-gunesi">
                        <Hidayet />
                     </Route>
                     <Route path="*">
                        <NotFound />
                     </Route>
                  </Switch>
               </main>
               {this.state.IsScrollBackBtnVisible &&
                  <BackTop style={{ fontSize: 20 }} />
               }
            </div>
            <footer className="footer">
               <Footer />
            </footer>

         </div>
      );
   }
}

export const NotFound = () => {
   return <div>This is a 404 page</div>
}
export const Videos = () => {
   return <div>Videos</div>
}
export const Fotos = () => {
   return <div>Fotos</div>
}

export default App;